import { Grid, makeStyles, Typography } from '@material-ui/core';
import commonStyles from '../../../styles';

const useStyles = makeStyles({
  dateWrp: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'auto',
    minWidth: '45px',
    flexShrink: 0,
  },
  red: {
    color: '#ff0000',
    whiteSpace: 'nowrap',
  },
});

function LastReceivedAt(props) {
  const { lastReceivedAt } = props;
  const common = commonStyles();
  const classes = useStyles();
  const isMinuteFormat = typeof lastReceivedAt === 'string' && lastReceivedAt.includes('分前');
  const date = new Date(lastReceivedAt);
  const Y = date.getFullYear();
  const M = date.getMonth() + 1; // 月は0から始まるので+1
  const D = date.getDate();
  const H = date.getHours();
  const m = String(date.getMinutes()).padStart(2, '0'); // 0埋め
  const isThisYear = Y === new Date().getFullYear();

  if (isMinuteFormat) {
    const minuteVal = lastReceivedAt.replace('分前', '');
    return (
      <Grid className={classes.dateWrp}>
        <Typography className={`${common.title2} ${classes.red}`} style={{ lineHeight: 1 }}>
          {minuteVal}
        </Typography>
        <Typography className={`${common.title5} ${classes.red}`} style={{ fontSize: '10px', marginTop: '2px' }}>
          分前
        </Typography>
      </Grid>
    );
  }

  return (
    <Grid className={classes.dateWrp}>
      {!isThisYear && <Typography className={common.title5}>{Y}</Typography>}
      <Typography className={common.title4}>{M}/{D}</Typography>
      <Typography className={common.title5}>{H}:{m}</Typography>
    </Grid>
  );
}

export default LastReceivedAt;
